/** @jsxImportSource @emotion/react */
import React from 'react'
import { FormatOptionLabelContext } from 'react-select'

// The name the system matched a payer by, when it is not the payer's own.
export const viaName = (name: string | null | undefined, matched: string | null | undefined): string | null =>
  matched?.trim() && matched.trim().toLowerCase() !== (name ?? '').trim().toLowerCase() ? matched.trim() : null

// A payer's real name with, in small print, the other name the system matched
// it by; shown only when the two differ.
export const PayerOptionLabel = ({ name, via }: { name: string; via?: string | null }) => {
  const shown = viaName(name, via)

  return (
    <>
      {name}
      {shown && (
        // Dimmed rather than gray, so it stays readable on a highlighted option.
        <small css={{ marginLeft: 6, opacity: 0.7 }}>
          via {shown}
        </small>
      )}
    </>
  )
}

// For a payer select: the "via" note in the open menu only, never on the
// chosen value.
export const formatPayerOptionLabel = <T extends { label?: string; matchedName?: string | null }>(
  option: T,
  { context }: { context: FormatOptionLabelContext },
): React.ReactNode =>
  context === 'menu' ? <PayerOptionLabel name={option.label ?? ''} via={option.matchedName} /> : option.label

// Search results are the server's: a payer found by an other name is listed
// under its real name, so the typed text is checked against both.
export const filterPayerOption = (option: { label: string; data: unknown }, input: string): boolean => {
  const search = input.trim().toLowerCase()
  const matchedName = (option.data as { matchedName?: string | null } | null)?.matchedName

  return !search || [option.label, matchedName].some((name) => name?.toLowerCase().includes(search))
}
